import type {
  ServicesByName,
  WorkflowServiceConfig,
} from 'flow/store/engine/types';
import type {
  PossibleValue,
  ServiceConfigOption,
} from '~/dashboard/views/settings/service-configuration/types';
import { CredentialOwner } from '~/dashboard/views/settings/service-configuration/types';
import type { ServiceConfigOptionPrimitive } from '../snippets/collisions/equivalency/types';

export function isGlobalServiceConfigOption(
  serviceConfigOption: ServiceConfigOptionPrimitive): boolean {
  return serviceConfigOption.category === 'global';
}
export function indexServiceConfigPossibleValuesBySlug(
  possibleValues: PossibleValue[]): Record<string, PossibleValue> {
  return Object.fromEntries(possibleValues.map(pv => [pv.slug, pv]));
}

/** merges global service config options into a service's SCOs for simplified look up */
export function mergeGlobalServiceConfigOptions({
  globalServiceConfigOptions,
  services,
}: {
  services: ServicesByName;
  globalServiceConfigOptions: ServiceConfigOption[];
}): ServicesByName {
  return Object.fromEntries(
    Object.entries(services).map(([name, svc]) => [name, {
      ...svc,
      serviceConfig: {
        ...svc.serviceConfig,
        serviceConfigOptions: [
          ...(svc.serviceConfig?.serviceConfigOptions ?? []),
          ...globalServiceConfigOptions,
        ],
      },
    }]),
  );
}

export function makeServiceConfig(
  overrides: Partial<WorkflowServiceConfig> = {},
): WorkflowServiceConfig {
  return {
    selectedAlloyOptions: { serviceConfigOptions: [] },
    selectedCustomerOptions: { credentialOwner: CredentialOwner.unknown, serviceConfigOptions: [] },
    serviceConfigOptions: [],
    ...overrides,
  };
}
